<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" @tab-click="handleClick">
        <el-tab-pane :lazy="true" :label="$t('AutomaticRelease.common.combinationTitle')" name="rulesCombination">
          <Single-Rule
            tab-index="0"
            config-module="2022072501"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('AutomaticRelease.common.ruleTitle')" name="SingleRule">
          <Single-Rule
            tab-index="1"
            config-module="2022072502"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('AutomaticRelease.common.AutomaticOrderReleaseTriggerSettings')" name="TriggerTheSettings">
          <TriggerTheSettings />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('AutomaticRelease.common.ReleaseGuaranteeSetting')" name="releaseGuaranteeSetting">
          <ReleaseGuaranteeSetting />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import SingleRule from '@/components/Cargo/Common/SingleRule/index'
import TriggerTheSettings from '@/components/Cargo/Common/SingleRule/triggerTheSettings'
import ReleaseGuaranteeSetting from '@/components/Cargo/Common/SingleRule/releaseGuaranteeSetting'

export default {
  name: 'PutASingleRule',
  components: { TriggerTheSettings, SingleRule, ReleaseGuaranteeSetting },
  data() {
    return {
      activeTabName: 'rulesCombination',
      tabIndex: '0',
      configModule: '2022072501'
    }
  },
  mounted() {
    this.configModule = '2022072501'
    this.activeTabName = 'rulesCombination'
  },
  methods: {
    handleClick(tab) {
      console.log(tab)
    }
  }
}
</script>
